module.exports = __webpack_public_path__ + "media/images/alpha-cdf1d4ce.png";